import { render, staticRenderFns } from "./RetailerCard.vue?vue&type=template&id=bb78f566&scoped=true"
import script from "./RetailerCard.vue?vue&type=script&lang=js"
export * from "./RetailerCard.vue?vue&type=script&lang=js"
import style0 from "./RetailerCard.vue?vue&type=style&index=0&id=bb78f566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb78f566",
  null
  
)

export default component.exports